import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

/**
 * Analiza estadísticas del flujo usando IA
 * @param {string} prompt - Instrucción del usuario
 * @param {Array} currentStats - Estadísticas actuales
 * @param {Object} columnsExample - Ejemplo de columnas
 * @param {string} clientId - ID del cliente
 * @param {string} workflowId - ID del flujo de trabajo
 * @returns {Promise<Object>} - Respuesta con message y query
 */
export const analyzeFlowStats = async (prompt, currentStats, columnsExample, clientId, workflowId) => {
  try {
    const response = await axios.post(`${API_URL}/workflows/${clientId}/statistics/${workflowId}/generate`, 
      {
        currentStats,
        columnsExample,
        prompt
      }
    );

    if (response.status === 200) {
      return {
        success: true,
        data: response.data.data // Contiene {message, query}
      };
    } else {
      console.error("Error en la respuesta del servidor:", response);
      return {
        success: false,
        error: "Error al analizar las estadísticas del flujo"
      };
    }
  } catch (error) {
    console.error("Error al llamar al endpoint de análisis de estadísticas:", error);
    return {
      success: false,
      error: error.message || "Error al analizar las estadísticas del flujo"
    };
  }
};

